import type { SVGProps } from "react";

export function IconBlackThreeArrows(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      fill="none"
      {...props}
    >
      <path d="M38 7H57V26L47.5 16.5L38 7Z" fill="#23232C" />
      <path
        d="M7 57L47.5 16.5M47.5 16.5L57 26V7H38L47.5 16.5Z"
        stroke="#23232C"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
      <path d="M38 37H57V56L47.5 46.5L38 37Z" fill="#23232C" />
      <path
        d="M37 57L47.5 46.5M47.5 46.5L38 37H57V56L47.5 46.5Z"
        stroke="#23232C"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
      <path d="M8 7H27V26L17.5 16.5L8 7Z" fill="#23232C" />
      <path
        d="M7 27L17.5 16.5M17.5 16.5L8 7H27V26L17.5 16.5Z"
        stroke="#23232C"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
    </svg>
  );
}
